import React, { useState } from 'react';
import { proposalsApi } from '../services/api';

const TestSimples: React.FC = () => {
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const testGetProposal = async () => {
    try {
      setError('');
      setResult(null);
      
      const proposalId = '2f2aa99c-1802-4519-b9e8-bcd6bb65b816';
      console.log('🔍 TESTE SIMPLES: Buscando proposta:', proposalId);
      console.log('🔍 TESTE SIMPLES: API URL:', process.env.REACT_APP_API_URL);
      
      const proposal = await proposalsApi.getProposal(proposalId);
      console.log('✅ TESTE SIMPLES: Sucesso!', proposal);
      setResult(proposal);
      
    } catch (err: any) {
      console.error('❌ TESTE SIMPLES: Erro!', err);
      console.error('❌ TESTE SIMPLES: Status:', err.response?.status);
      console.error('❌ TESTE SIMPLES: Data:', err.response?.data);
      console.error('❌ TESTE SIMPLES: URL:', err.config?.url);
      setError(`Status: ${err.response?.status} - ${err.response?.data?.detail || err.message}`);
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-base font-bold mb-4">Teste Simples - Buscar Proposta</h1>
      
      <div className="mb-4">
        <button
          onClick={testGetProposal}
          className="bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700"
        >
          Buscar Proposta (ID: 2f2aa99c...)
        </button>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
          <h3 className="font-bold">Erro:</h3>
          <p>{error}</p>
        </div>
      )}

      {result && (
        <div className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
          <h3 className="font-bold">Sucesso:</h3>
          <p>ID: {result.id}</p>
          <p>Number: {result.number}</p>
          <p>Status: {result.status}</p>
        </div>
      )}
    </div>
  );
};

export default TestSimples;